<template>
  <div id="app" class="tw-min-h-screen tw-bg-white">
    <TopHeader />
    <HeaderNavigation />
    <RouterView />
    <FooterSection />
    <GlobalCTABar />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router';

import TopHeader from './components/TopHeader.vue';
import HeaderNavigation from './components/HeaderNavigation.vue';
import FooterSection from './components/FooterSection.vue';
import GlobalCTABar from './components/GlobalCTABar.vue';
</script>
